"use client";

import { motion, useReducedMotion } from "framer-motion";
import { OffersCurvedHeroText, OffersFlatHeroText } from "./offers-curved-hero-text";
import { OFFERS_HERO_BLUR_DURATION } from "./offers-hero-motion";

const SEQUENCE_EASE = [0.16, 1, 0.3, 1] as const;

export function OffersHero() {
  const reducedMotion = useReducedMotion();

  return (
    <div className="relative bg-[#f3f3f3] px-6 pb-0 pt-2 md:pt-2">
      <motion.div
        className="relative mx-auto w-full max-w-3xl"
        initial={
          reducedMotion
            ? false
            : {
                opacity: 0,
                y: 12,
                filter: "blur(16px)",
              }
        }
        animate={{
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
        }}
        transition={
          reducedMotion
            ? { duration: 0 }
            : {
                duration: OFFERS_HERO_BLUR_DURATION,
                ease: SEQUENCE_EASE,
              }
        }
      >
        {reducedMotion ? <OffersFlatHeroText /> : <OffersCurvedHeroText />}
      </motion.div>
    </div>
  );
}
